import { render, staticRenderFns } from "./StoryCreate.vue?vue&type=template&id=d861de06&scoped=true"
import script from "./StoryCreate.vue?vue&type=script&lang=js"
export * from "./StoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d861de06",
  null
  
)

export default component.exports